export default __webpack_public_path__ + "static/media/laptop.bf198aa6.png";